import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import '../PageLayout/PageLayout.scss'
import {actions} from '../../security/modules/actionsAuth'
import logonotfound from '../../image/404notfound.png'

export const NotFoundLayout = ({ children , auth, authenticationLogin, authenticationLogout}) => (
  <div className="container">
    <div className="row">
        <div className="col-5 text-center" id="NotFound" >
          <h1>Uuups! :( </h1>
          <h2>Lo sentimos, la página no ha sido encontrada.</h2>
          <p> <button type="button" className="btn btn-secondary" onClick={authenticationLogin} > Volver al inicio </button> </p>
        </div>
        <div className="col-5 col-middle text-center">
        <img src={logonotfound} width="780" alt="Pagina no encontrada" />
        </div>
      </div>
  </div>
)
NotFoundLayout.propTypes = {
  children: PropTypes.node,

}

const mapDispatchToProps = {
  authenticationLogin: actions.authenticationLogin,
  authenticationLogout: actions.authenticationLogout
}

const mapStateToProps = (state) => ({
   auth : state.auth
})

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundLayout)



// WEBPACK FOOTER //
// ./src/layouts/NotFoundLayout/NotFoundLayout.js